import { render, staticRenderFns } from "./StatisticsReferralsFilters.vue?vue&type=template&id=54dc86b0&scoped=true&"
import script from "./StatisticsReferralsFilters.vue?vue&type=script&lang=js&"
export * from "./StatisticsReferralsFilters.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsReferralsFilters.vue?vue&type=style&index=0&id=54dc86b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dc86b0",
  null
  
)

export default component.exports